export const AWS_CONFIG = {
  /* User Pool ID */
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID ?? '', //
  /* Cognito Client ID */
  userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID ?? '',
  /* Cognito Region */
  region: process.env.REACT_APP_AWS_REGION ?? '', //
  // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
  identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  // OPTIONAL - Amazon Cognito Federated Identity Pool Region
  // Required only if it's different from Amazon Cognito Region
  identityPoolRegion: 'us-east-2',

  Storage: {
    // REQUIRED - S3 bucket name for chat attachments
    bucket: process.env.REACT_APP_AWS_THUMBNAIL_BUCKET,
    // REQUIRED - Amazon S3 Region
    region: 'us-east-2',
    // REQUIRED Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  },
  /* 
    /* 
  /* 
    **
    For OAuth configuration, If you wanna use a 3th 
    factor authentication, like facebook, google or any other 
    you need to have that configuration in your AWS Cognito account 
    **
    */
  oauth: {
    /* Application domain */
    domain: '',

    /* Redirect url executing sign in */
    redirectSignIn: 'topflightapps://authentication/',

    /* Redirect url executing sign out */
    redirectSignOut: 'topflightapps://authentication/',

    /* 
    **
    'code' for Authorization code grant, 
    'token' for Implicit grant
    Note that REFRESH token will only be generated when the responseType is code 
    **
    */
    responseType: 'code',

    /* Authorized scopes 'phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin' */
    scope: ['phone', 'email'],
  },

  /* User Pool ID */
  /* federationTarget: "", */
};
